{
  "version": "2026-07-12",
  "source": "https://platform.claude.com/docs/en/about-claude/pricing",
  "currency": "USD",
  "per_mtok": {
    "claude-fable-5": {
      "input": 10,
      "output": 50,
      "cache_read": 1,
      "cache_write_5m": 12.5,
      "cache_write_1h": 20
    },
    "claude-mythos-5": {
      "input": 10,
      "output": 50,
      "cache_read": 1,
      "cache_write_5m": 12.5,
      "cache_write_1h": 20
    },
    "claude-opus-4-8": {
      "input": 5,
      "output": 25,
      "cache_read": 0.5,
      "cache_write_5m": 6.25,
      "cache_write_1h": 10,
      "fast_input": 10,
      "fast_output": 50
    },
    "claude-opus-4-7": {
      "input": 5,
      "output": 25,
      "cache_read": 0.5,
      "cache_write_5m": 6.25,
      "cache_write_1h": 10,
      "fast_input": 30,
      "fast_output": 150
    },
    "claude-opus-4-6": {
      "input": 5,
      "output": 25,
      "cache_read": 0.5,
      "cache_write_5m": 6.25,
      "cache_write_1h": 10
    },
    "claude-opus-4-5": {
      "input": 5,
      "output": 25,
      "cache_read": 0.5,
      "cache_write_5m": 6.25,
      "cache_write_1h": 10
    },
    "claude-opus-4-1": {
      "input": 15,
      "output": 75,
      "cache_read": 1.5,
      "cache_write_5m": 18.75,
      "cache_write_1h": 30
    },
    "claude-opus-4": {
      "input": 15,
      "output": 75,
      "cache_read": 1.5,
      "cache_write_5m": 18.75,
      "cache_write_1h": 30
    },
    "claude-sonnet-5": [
      {
        "until": "2026-09-01",
        "input": 2,
        "output": 10,
        "cache_read": 0.2,
        "cache_write_5m": 2.5,
        "cache_write_1h": 4
      },
      {
        "from": "2026-09-01",
        "input": 3,
        "output": 15,
        "cache_read": 0.3,
        "cache_write_5m": 3.75,
        "cache_write_1h": 6
      }
    ],
    "claude-sonnet-4-6": {
      "input": 3,
      "output": 15,
      "cache_read": 0.3,
      "cache_write_5m": 3.75,
      "cache_write_1h": 6
    },
    "claude-sonnet-4-5": {
      "input": 3,
      "output": 15,
      "cache_read": 0.3,
      "cache_write_5m": 3.75,
      "cache_write_1h": 6
    },
    "claude-sonnet-4": {
      "input": 3,
      "output": 15,
      "cache_read": 0.3,
      "cache_write_5m": 3.75,
      "cache_write_1h": 6
    },
    "claude-3-7-sonnet": {
      "input": 3,
      "output": 15,
      "cache_read": 0.3,
      "cache_write_5m": 3.75,
      "cache_write_1h": 6
    },
    "claude-3-5-sonnet": {
      "input": 3,
      "output": 15,
      "cache_read": 0.3,
      "cache_write_5m": 3.75,
      "cache_write_1h": 6
    },
    "claude-haiku-4-5": {
      "input": 1,
      "output": 5,
      "cache_read": 0.1,
      "cache_write_5m": 1.25,
      "cache_write_1h": 2
    },
    "claude-haiku-3-5": {
      "input": 0.8,
      "output": 4,
      "cache_read": 0.08,
      "cache_write_5m": 1,
      "cache_write_1h": 1.6
    },
    "claude-3-5-haiku": {
      "input": 0.8,
      "output": 4,
      "cache_read": 0.08,
      "cache_write_5m": 1,
      "cache_write_1h": 1.6
    },
    "claude-3-haiku": {
      "input": 0.25,
      "output": 1.25,
      "cache_read": 0.03,
      "cache_write_5m": 0.3,
      "cache_write_1h": 0.5
    },
    "claude-3-opus": {
      "input": 15,
      "output": 75,
      "cache_read": 1.5,
      "cache_write_5m": 18.75,
      "cache_write_1h": 30
    }
  }
}
